import React from 'react';
import PropTypes from 'prop-types';
import { partial } from '../../util/translation/translation';
import { PhoneTabBar } from './MorePhonePreview';

// Shown with their name over the shared spotlight picture, as they have no
// picture of their own
const TITLED = [
  'spotlight',
  'youTubeFeed',
  'externalLiveScore',
  'NTFGoalFeed',
  'custom',
];

/**
 * The app's home screen on a phone, with its components from the top and
 * the floating tab bar, Home selected: how the bottom menu looks to fans.
 */
const HomePhonePreview = ({ home, tabs, chosenIcon }) => {
  const p = partial('appLayout');
  return (
    <div className="phone-more" aria-label={p('preview')}>
      <div className="phone-more__screen">
        <div className="phone-more__content phone-more__content--home">
          {home.map((item) =>
            TITLED.some((id) => item.id.includes(id)) ? (
              <div className="phone-more__section" key={item.id}>
                <span className="phone-more__section-title">{item.name}</span>
                <img
                  alt=""
                  src="/assets/files/homepage/new-spotlight-homescreen.png"
                />
              </div>
            ) : (
              <img
                alt={item.name}
                key={item.id}
                src={`/assets/files/homepage/${item.id}-homescreen.png`}
              />
            )
          )}
        </div>
        <PhoneTabBar tabs={tabs} selected="home" chosenIcon={chosenIcon} />
      </div>
    </div>
  );
};

HomePhonePreview.propTypes = {
  home: PropTypes.arrayOf(PropTypes.object),
  tabs: PropTypes.arrayOf(PropTypes.object),
  chosenIcon: PropTypes.func.isRequired,
};

HomePhonePreview.defaultProps = {
  home: [],
  tabs: [],
};

export default HomePhonePreview;
